/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GuidePage = lazyLoad(
  () => import('./index'),
  module => module.GuidePage
);
